export class NotificationPageParams {
  onlyUnread?: boolean;

  constructor(init: NotificationPageParams) {
    Object.assign(this, init);
  }
}
